export enum AdminRoutePathsEnum {
  DASHBOARD = '/admin',
}
